import React, { useState, HTMLProps, HTMLAttributes } from 'react';

import {
  View,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphBlockReferenceEntity } from '..';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphBlockReferenceEntity;
}

const ParagraphBlockReference: React.FC<Props> = ({ entity, className }) => {
  const [blockType, blockId] = String(entity.getIn(['field_block_reference', 0, 'value'], '')).split('__');
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});

  const { buildClass, joinClasses } = useClasses('ParagraphBlockReference');

  // We only support view blocks for now.
  if (blockType === 'views_block') {
    const [viewId] = blockId.split('_', 1);
    const viewDisplay = blockId.replace(`${viewId}_`, '');

    return (
      <div className={joinClasses(buildClass(), className)}>
        <View
          id={viewId}
          display={viewDisplay}
          page={currentPage}
          filters={filters}
          setCurrentPage={setCurrentPage}
          setFilters={setFilters}
        />
      </div>
    );
  }

  return (
    <div className={joinClasses(buildClass(), className)}>
      <p>Block id: {entity.getIn(['field_block_reference', 0, 'value'], '')}</p>
    </div>
  );
};

export default ParagraphBlockReference;
